import App from "./App";
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import pages from "./components/pages";
import Page404 from "./components/404";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      ...pages.map((page) => ({
        path: page.route,
        element: <></>,
      })),
      {
        path: "404",
        element: <Page404 />,
      },
      {
        path: "*",
        element: <Navigate to="/404" replace />,
      },
    ],
  },
]);

const Router = () => {
  return <RouterProvider router={router} />;
};

export default Router;
